import { camelCase, includes, replace } from 'lodash';

/**
 * Gather the search parameters and configure them.
 *
 * @param {*} params page, limit, filters, sort, and rest parameters
 */
export const prepareSearchParams = (params) => {
  const { page, limit, filters, sort, ...restData } = params;
  const preparedParams = {
    page_size: limit,
    ...filters,
    ...restData,
  };

  if (page > 1) preparedParams.page_number = page - 1;

  if (sort) {
    preparedParams.order_by_asc = includes(sort, ',asc');
    let sortAttribute = replace(sort, 'filter_by_', '');

    sortAttribute = replace(sortAttribute, ',asc', '');
    sortAttribute = replace(sortAttribute, ',desc', '');
    preparedParams.sort_attribute = camelCase(sortAttribute);
  }

  return preparedParams;
};

export const yupErrorHandler = (errors) => {
  if (Array.isArray(errors)) {
    return {
      errors: {
        msg: errors.join(' '),
      },
    };
  }

  return {
    errors,
  };
};
